if (!customElements.get("variant-dropdown-cp")) {
  customElements.define(
    "variant-dropdown-cp",

    class VariantDropdownCP extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.productId = this.dataset.productId;
        this.variants = JSON.parse(
          this.querySelector('[type="application/json"]').innerHTML
        );

        this.select = this.querySelector("select");
        this.select.addEventListener("change", this.onChange.bind(this));
      }

      onChange(e) {
        const selectedVariant = this.variants.find(
          (variant) => variant.title === e.target.value
        );
        // console.log('selectedVariant', selectedVariant);

        messenger.emmit(messenger.topics.SET_VARIANT_INPUT_ON_PRODUCT_CARD, {
          productId: this.productId,
          variantId: selectedVariant.id.toString(),
        });
        messenger.emmit(messenger.topics.CHANGE_PRODUCT_CARD_IMAGE, {
          index: null,
          productId: this.productId,
          variantId: selectedVariant.id.toString(),
        });
      }
    }
  );
}
